import React from 'react';
import { NetworkIcon, PlusIcon } from 'lucide-react';
interface SchemasViewProps {
  userPlan: string;
}
export function SchemasView({
  userPlan
}: SchemasViewProps) {
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-341">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-342">
        <div data-id="element-343">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-344">
            Schemas & Mapping
          </h2>
          <p className="text-sm text-gray-600 mt-1" data-id="element-345">
            Define and map data schemas for your AI models
          </p>
        </div>
        <button disabled={userPlan === 'Free'} className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-346">
          <PlusIcon className="w-4 h-4" data-id="element-347" />
          New Schema
        </button>
      </div>
      {/* Content placeholder */}
      <div className="bg-white rounded-lg border border-gray-200 p-8 text-center" data-id="element-348">
        <NetworkIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" data-id="element-349" />
        <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-350">
          Schema Management
        </h3>
        <p className="text-sm text-gray-600 max-w-md mx-auto" data-id="element-351">
          {userPlan === 'Free' ? 'This is a read-only demo. Upgrade to create and manage data schemas.' : 'Create, map and manage schemas to organize your data for AI processing.'}
        </p>
      </div>
    </div>;
}